export default __webpack_public_path__ + "static/person-img-7694e84941ef2019d3a0617d48bfd9f3.jpg";